import ThreeDTourIcon from '@propertypal/shared/src/resources/icons/tours/white-3D-tour-icon.svg';
import AudioTourIcon from '@propertypal/shared/src/resources/icons/tours/white-audio-tour-icon.svg';
import BookTourIcon from '@propertypal/shared/src/resources/icons/tours/white-brochure-icon.svg';
import FloorPlanIcon from '@propertypal/shared/src/resources/icons/tours/white-floorplan-tour.svg';
import VideoTourIcon from '@propertypal/shared/src/resources/icons/tours/white-play-icon.svg';
import GenericTourIcon from '@propertypal/shared/src/resources/icons/tours/white-virtual-tour-genric-icon.svg';
import VirtualTourIcon from '@propertypal/shared/src/resources/icons/tours/white-virtual-tour-icon.svg';
import { GalleryItem } from '@propertypal/shared/src/utils/property/getGalleryImages';
import React, { FunctionComponent } from 'react';

interface Props {
  image: GalleryItem;
}

const TourIcon: FunctionComponent<Props> = (props) => {
  const { image } = props;

  return (
    <>
      {(image.tourType === 'generic' || image.tourType === 'virtual-tour') && <GenericTourIcon viewBox="0 0 20 20" />}
      {image.tourType === '360-tour' && <VirtualTourIcon viewBox="0 0 19 20" />}
      {image.tourType === '3d-tour' && <ThreeDTourIcon viewBox="0 0 18 20" />}
      {image.tourType === 'audio' && <AudioTourIcon viewBox="0 0 17 15" />}
      {image.tourType === 'book' && <BookTourIcon viewBox="0 0 24 18" />}
      {image.tourType === 'floorplan' && <FloorPlanIcon viewBox="0 0 21 17" />}
      {image.tourType === 'video' && <VideoTourIcon viewBox="0 0 58 70" />}
      {image.type === 'video' && <VideoTourIcon viewBox="0 0 58 70" />}
    </>
  );
};

export default TourIcon;
